import React from 'react';
import { PEERSONA_GRADIENT_FROM, PEERSONA_GRADIENT_TO } from './peersona-styles';

interface Props {
  size?: number;
  /** Optional photo URL. When present, rendered as a circular img. */
  src?: string | null;
  /** Falls back to first letter of name when src is absent. */
  name?: string;
}

/**
 * Avatar for the Peersona panel. Prefers the ChatBot's avatar_file_path when
 * provided; otherwise renders a soft gradient circle with the initial letter
 * (matches Fi's blob aesthetic but with a different palette).
 */
export const PeersonaAvatar: React.FC<Props> = ({ size = 28, src, name }) => {
  const dimension = `${size}px`;
  if (src) {
    return (
      <img
        src={src}
        alt={name ? `${name} avatar` : 'Peersona avatar'}
        width={size}
        height={size}
        className="shrink-0 rounded-full object-cover"
        style={{ width: dimension, height: dimension }}
      />
    );
  }
  const letter = (name ?? '?').trim().charAt(0).toUpperCase() || '?';
  return (
    <span
      aria-hidden
      className="font-albert-sans inline-grid shrink-0 place-items-center rounded-full text-white shadow-sm"
      style={{
        width: dimension,
        height: dimension,
        fontSize: Math.round(size * 0.45),
        background: `linear-gradient(135deg, ${PEERSONA_GRADIENT_FROM} 0%, ${PEERSONA_GRADIENT_TO} 100%)`,
      }}
    >
      {letter}
    </span>
  );
};
